import { render, staticRenderFns } from "./LearningGoalResults.vue?vue&type=template&id=1909b240&"
import script from "./LearningGoalResults.vue?vue&type=script&lang=js&"
export * from "./LearningGoalResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports